module.exports = __webpack_public_path__ + "img/americo-bw-logo-img-desktop.e8a94ff5.svg";